import React, { useContext, useMemo, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaBook,
  FaChevronDown,
  FaChevronRight,
  FaSignOutAlt,
  FaExchangeAlt,
  FaUserCog,
} from "react-icons/fa";
import {
  MdAssignment,
  MdBrandingWatermark,
  MdCategory,
  MdGroup,
  MdInventory,
  MdStorefront,
  MdPhone,
  MdShoppingCart,
} from "react-icons/md";

const Sidebar = ({
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
}) => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({
    master: true,
    transaksi: true,
    utility: true,
  });

  const menus = useMemo(
    () => [
      {
        id: "master",
        label: "Master",
        icon: <FaBook />,
        children: [
          {
            id: "kategori",
            label: "Kategori",
            icon: <MdCategory />,
            to: "/kategori",
          },
          {
            id: "merk",
            label: "Merk",
            icon: <MdBrandingWatermark />,
            to: "/merk",
          },
          {
            id: "barang",
            label: "Barang",
            icon: <MdInventory />,
            to: "/barang",
          },
          {
            id: "adminWhatsapp",
            label: "WA Admin",
            icon: <MdPhone />,
            to: "/adminWhatsapp",
          },
          {
            id: "informasiToko",
            label: "Informasi Toko",
            icon: <MdStorefront />,
            to: "/informasiToko",
          },
        ],
      },
      {
        id: "transaksi",
        label: "Transaksi",
        icon: <FaExchangeAlt />,
        children: [
          {
            id: "keranjang",
            label: "Keranjang",
            icon: <MdShoppingCart />,
            to: "/keranjang",
          },
          {
            id: "pesanan",
            label: "Pesanan",
            icon: <MdAssignment />,
            to: "/pesanan",
          },
        ],
      },
      {
        id: "utility",
        label: "Utility",
        icon: <FaUserCog />,
        children: [
          {
            id: "daftarUser",
            label: "Daftar User",
            icon: <MdGroup />,
            to: "/daftarUser",
          },
        ],
      },
    ],
    [],
  );

  const toggleMenu = (menuId) => {
    setOpenMenus((currentMenus) => ({
      ...currentMenus,
      [menuId]: !currentMenus[menuId],
    }));
  };

  const logoutButtonHandler = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/");
  };

  return (
    <aside
      className={`app-sidebar ${collapsed ? "collapsed" : ""} ${
        toggled ? "mobile-open" : ""
      }`}
    >
      <div className="sidebar-brand">
        <span className="brand-mark">A</span>
        {!collapsed && <span className="brand-text">AJS ECOMMERCE</span>}
        <button
          className="sidebar-collapse-btn"
          type="button"
          onClick={handleCollapsedChange}
          aria-label="Toggle sidebar"
        >
          {collapsed ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
        </button>
      </div>

      <nav className="sidebar-nav">
        {menus
          .map((menu) => ({
            ...menu,
            children: menu.children.filter(
              (child) => user.akses?.[child.id],
            ),
          }))
          .filter((menu) => menu.children.length > 0)
          .map((menu) => (
            <div
              key={menu.id}
              className="sidebar-node depth-0"
            >
              <button
                className={`sidebar-menu-button ${
                  menu.children.some((child) =>
                    location.pathname.startsWith(child.to),
                  )
                    ? "active-branch"
                    : ""
                }`}
                type="button"
                onClick={() => toggleMenu(menu.id)}
                title={menu.label}
                aria-expanded={openMenus[menu.id]}
              >
                <span className="sidebar-menu-icon">{menu.icon}</span>
                {!collapsed && (
                  <>
                    <span className="sidebar-menu-label">{menu.label}</span>
                    <span className="sidebar-menu-chevron">
                      {openMenus[menu.id] ? (
                        <FaChevronDown />
                      ) : (
                        <FaChevronRight />
                      )}
                    </span>
                  </>
                )}
              </button>

              {!collapsed && openMenus[menu.id] && (
                <div className="sidebar-children">
                  {menu.children.map((child) => (
                    <NavLink
                      key={child.id}
                      className="sidebar-link depth-1"
                      to={child.to}
                      onClick={() => handleToggleSidebar(false)}
                      title={child.label}
                    >
                      <span className="sidebar-menu-icon">{child.icon}</span>
                      <span>{child.label}</span>
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
      </nav>

      <div className="sidebar-footer">
        {!collapsed && <div className="sidebar-user">{user.username}</div>}
        <button className="logout-btn" type="button" onClick={logoutButtonHandler}>
          {!collapsed && <span>Logout</span>}
          <FaSignOutAlt />
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
